<template>
    <i class="i-ph-caret-right mt-0.5" />
    <targeting-router-link class="crumb" :to="TRANSACTION_JOURNAL">
        <i class="i-ph-list-fill mt-0.5" />Bilagsjournal
    </targeting-router-link>
    <i class="i-ph-caret-right mt-0.5" />
    <div class="crumb truncate line-clamp-1">
        <i class="i-ph-file-text-fill mt-0.5"/><div>{{ transaction?.transactionName }}</div>
    </div>
</template>

<script setup lang="ts">
import { TargetingRouterLink } from '@tritt/multipanel'
import { getTransactionByUuid } from '@/transaction/transaction.service'
import { TRANSACTION_JOURNAL } from '@/transaction-journal'
import { Transaction } from '@/types/transaction/Transaction'
import { onMounted, ref, watch } from 'vue'

// TODO: Fix reloading. Timing org selected?

const props = defineProps({
    transactionUuid: {
        type: String,
        required: true
    },
})

const transaction = ref<Transaction>()

const loadTransaction = async () => {
    if(props.transactionUuid) {
        transaction.value = await getTransactionByUuid(props.transactionUuid)
    }
}

onMounted(loadTransaction)

watch(() => props.transactionUuid, uuid => {
    if(uuid) {
        loadTransaction()
    }
})
 
</script>

<style scoped></style>